import React from "react";
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import { useStyles } from "./styles";
import Tooltip from '@material-ui/core/Tooltip';

const ButtonEdit = (props) =>{
    const classes = useStyles();
    const {onClick} = props;
    return (
    <Tooltip title="Editar">
        <IconButton aria-label="delete" onClick={onClick} className={classes.margin}>
            <EditIcon />
        </IconButton>
    </Tooltip>
    )
}
export default ButtonEdit;
